var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"context-menu",style:(_vm.style),attrs:{"tabindex":"-1"},on:{"!contextmenu":function($event){$event.preventDefault();},"blur":_vm.close}},[_c('ul',[_vm._t("default",null,{"contextData":_vm.contextData})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }